import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { CustomProvider as RSuiteProvider } from 'rsuite';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import './lib/posthog';
import { persistor, store } from './stores';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <React.Suspense fallback={<div>Loading...</div>}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <ErrorBoundary>
              <RSuiteProvider>
                <App />
              </RSuiteProvider>
            </ErrorBoundary>
          </PersistGate>
        </Provider>
      </React.Suspense>
    </PostHogProvider>
  </React.StrictMode>
);
